import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { GetWishListApiParameter, getWishList } from "@NA/Services/ADIWishListService";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    WishListLineCollectionModel,
    WishListLineModel,
    WishListModel,   
} from "@insite/client-framework/Types/ApiModels";

export interface LoadWishListResult {
    apiResult: WishListModel;
    pagination: any;
    wishListLines?: WishListLineModel[];
    onSuccess?: (result: WishListLineCollectionModel) => void;    
}

type HandlerType = Handler<
    GetWishListApiParameter & HasOnSuccess & { wishListId: string; name?: string; parameter?: any },
    LoadWishListResult
>;

export const DispatchBeginLoadWishList: HandlerType = props => {
    props.dispatch({
        type: "Data/WishLists/BeginLoadWishList",
        wishListId: props.parameter.wishListId,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getWishList(props.parameter);
    props.pagination = props.apiResult.pagination;
    props.wishListLines = props.apiResult.wishListLineCollection!;
};

export const MapProducts: HandlerType = (props: any) => {
    props.productInfosByWishListLineId = {};
    props.wishListLines?.forEach((o: any) => {
        props.productInfosByWishListLineId[o.id] = {
            productId: o.productId,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.unitOfMeasure,
            productDetailPath: o.productUri,
        };
    });
};

export const LoadRealTimePrices: HandlerType = async (props: any) => {
    const { wishListLines, productInfosByWishListLineId } = props;

    if (!wishListLines?.length) {
        props.pricingLoaded = true;
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: wishListLines!.map((o: any) => ({
                productId: o.productId,
                unitOfMeasure: o.unitOfMeasure,
                qtyOrdered: o.qtyOrdered,
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach(pricing => {
                        for (const wishListLineId in productInfosByWishListLineId) {
                            const productInfo = productInfosByWishListLineId[wishListLineId]!;
                            if (
                                productInfo.productId === pricing.productId &&
                                productInfo.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                productInfo.pricing = pricing;  
                            }
                        }                      
                    });
                } else if (realTimePricingProps.error) {
                    for (const wishListLineId in productInfosByWishListLineId) {
                        productInfosByWishListLineId[wishListLineId]!.failedToLoadPricing = true;
                    }
                }
                props.pricingLoaded = true;          
            },
        }),
    );

    await waitFor(() => !!props.pricingLoaded);
};

export const LoadRealTimeInventory: HandlerType = (props: any) => {
    const { wishListLines, productInfosByWishListLineId } = props;
    if (!wishListLines?.length || true) {
        props.inventoryLoaded = true;
        props.parameter.onSuccess(props);
        return;
    }

    // const wishListLineIds = Object.keys(productInfosByWishListLineId);
    // props.dispatch(
    //     loadRealTimeInventory({
    //         productIds: wishListLineIds.map(o => productInfosByWishListLineId[o]!.productId),
    //         onComplete: realTimeInventoryProps => {
    //             if (realTimeInventoryProps?.error) {
    //                 wishListLineIds.forEach(o => {
    //                     const productInfo = productInfosByWishListLineId[o]!;
    //                     if (productInfo) {
    //                         productInfo.failedToLoadInventory = true;
    //                     }
    //                 });
    //             } else {
    //                 realTimeInventoryProps?.apiResult?.realTimeInventoryResults?.forEach(inventory => {
    //                     wishListLineIds.forEach(o => {
    //                         const productInfo = productInfosByWishListLineId[o]!;
    //                         if (productInfo.productId === inventory.productId) {
    //                             productInfo.inventory = inventory;
    //                         }
    //                     });
    //                 });
    //             }

    //             props.inventoryLoaded = true;
    //         },
    //     }),
    // );

    // props.parameter.onSuccess(props);
};

export const DispatchCompleteLoadWishList: HandlerType = ({ dispatch, apiResult }) => {
    dispatch({
        type: "Data/WishLists/CompleteLoadWishList",
        wishList: apiResult,
    });
};


export const chain = [
    DispatchBeginLoadWishList,
    RequestDataFromApi,
    MapProducts,
    LoadRealTimePrices,
    LoadRealTimeInventory,
    DispatchCompleteLoadWishList,
    
];

const loadWishList = createHandlerChainRunner(chain, "LoadWishList");
export default loadWishList;
